<mat-form-field [attr.data-form-field]="field" [appearance]="appearance" [formGroup]="formGroup" class="full-width">
  @if (label) {
    <mat-label class="label">{{ label | translate }}</mat-label>
  }

  <mat-date-range-input [formGroup]="formGroup" [rangePicker]="picker">
    <input
      matStartDate
      [formControlName]="field"
      [placeholder]="'commons.labels.start.date' | translate"
      [readonly]="readonly"
      [required]="mandatory"
      [min]="minValue"
      [max]="maxValue"
      [id]="field + '-input'"
      />
    <input
      matEndDate
      [formControlName]="fieldEnd"
      [placeholder]="'commons.labels.end.date' | translate"
      [readonly]="readonly"
      [required]="mandatory"
      [min]="minValue"
      [max]="maxValue"
      [id]="fieldEnd + '-input'"
      />
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker #picker></mat-date-range-picker>

  <!-- The mat-error tag HAS to be directly inside the mat-form-field otherwise it doesn't render properly if inside the ng-container -->
  <mat-error>
    @for (e of displayedErrors(); track e) {
      <span [attr.data-form-field-error]="e.error">
        {{ e.messageKey | translate : formGroup.controls[field]?.getError(e.error) || formGroup.controls[fieldEnd]?.getError(e.error) }}
      </span>
    }
  </mat-error>
  @if (hint) {
    <mat-hint>{{ hint }}</mat-hint>
  }
</mat-form-field>
